import { createContext, useMemo } from 'react'
import useCenterModal, {
	UseCenterModalReturn as CenterModalType,
} from 'src/hooks/popup/modal/useCenterModal'
import CenterModal from 'src/components/popup/modal/CenterModal'

const CenterModalContext = createContext<CenterModalType>({} as CenterModalType)

type ProviderProps = {
	children: React.ReactNode | React.ReactNode[]
}

const CenterModalProvider = ({ children }: ProviderProps) => {
	const {
		centerModalVisible,
		centerModalContent,
		onCenterModalComplete,
		onCenterModalCancel,
		openCenterModal,
		closeCenterModal,
	} = useCenterModal()

	const value = useMemo(
		() => ({
			centerModalVisible,
			centerModalContent,
			onCenterModalComplete,
			onCenterModalCancel,
			openCenterModal,
			closeCenterModal,
		}),
		[
			centerModalContent,
			centerModalVisible,
			onCenterModalCancel,
			onCenterModalComplete,
			openCenterModal,
			closeCenterModal,
		],
	)
	return (
		<CenterModalContext.Provider value={value}>
			{children}
			<CenterModal
				visible={centerModalVisible}
				dataList={centerModalContent}
				onComplete={onCenterModalComplete}
				onCancel={onCenterModalCancel}
			/>
		</CenterModalContext.Provider>
	)
}
export { CenterModalContext, CenterModalProvider }
